/**
 * REM 响应式方案，需移动端配合 px2rem 使用
 */
const baseWidth = 375
const documentElement = document.documentElement

/**
 * 设置html根字体
 */
function setRootFont(): void {
  const docWidth = documentElement.getBoundingClientRect().width
  const scale = docWidth / baseWidth
  const pixelRatio = window.devicePixelRatio === 3 ? 3 : 2

  documentElement.style.fontSize = `${scale * 100}px`
  documentElement.setAttribute('data-dpr', pixelRatio.toString())
}

setRootFont()
window.addEventListener('resize', setRootFont, false)
